<template>
  <v-row justify="center">
    <v-dialog
      style="z-index: 1022;"
      v-model="dialog"
      scrollable
      max-width="580px"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="newHomepageBtn"
          v-bind="attrs"
          v-on="on"
          rounded
          outlined
        >
          <p class="newHomepageBtn--text">Ny hjemmeside</p>
          <p class="newHomepageBtn--text-small">Ny</p>
          <v-icon class="newHomepageBtn--icon" color="#472449" size="28">mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="modal-card-title">Ny hjemmeside - velg avdelinger</v-card-title>
        <v-card-subtitle class="modal-card-subtitle">
          <span>For å opprette en ny hjemmeside trenger du å knytte denne til en eller flere av av dine eksiterende salonger eller avdelinger. Disse vil da tilhøre denne hjemmesiden. Du kan også når som helst flytte avdelinger mellom hjemmesider i hjemmesideverktøyet senere.</span>
        </v-card-subtitle>
        <v-card-text class="modal-card-text" style="height: 320px; ">
          <v-checkbox
            class="modal-card-text-checkbox"
            v-for="(department, index) in departments"
            multiple
            v-model="selected"
            :hide-details="index !== departments.length - 1"
            :key="department.index"
            :value="department"
            :label="department.siteName + ' ( ' + department.homepageUrl+ ' )'"
            @change="check"
            />
        </v-card-text>
        <v-card-actions class="dialog-actionbar">
          <span class="red--text" >{{ruleMessage}}</span>
          <v-spacer></v-spacer>
          <v-btn
            class="dialog-actionbar-btn dialog-actionbar-btn-close"
            color="#472449"
            text
            @click="dialog = false"
          >
            Avbryt
          </v-btn>
          <v-btn
            class="dialog-actionbar-btn dialog-actionbar-btn-create white--text"
            color="#EA412A"
            @click="createMethod"
            rounded
            :disabled="createDisabled"
          >
            <span> Opprett ny hjemmeside </span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
  export default {
    data () {
      return {
        dialogm1: '',
        dialog: false,
        selected: [],
        ruleMessage: '',
        createDisabled: true
      }
    },
    methods: {
      check () {
        if (this.selected.length <= 0) {
          this.createDisabled = true
          this.ruleMessage = 'Du må velge en avdeling for å opprette'
        } else {
          this.createDisabled = false
          this.ruleMessage = ''
        }
        this.cmsConfigHomepages.forEach((cmsConfig) => {
          var match = this.selected.filter(x => x.homepageUrl === cmsConfig.Dto.SiteUrl)
          if (match.length === cmsConfig.Dto.Sites.length) {
            this.ruleMessage = 'Må være minst en igjen på hver nettside'
            this.createDisabled = true
          }
        })
      },
      async createMethod () {
        this.dialog = false
        var siteIds = this.selected.map(x => x.siteId)
        await this.$store.dispatch('global/createNewHomepage',
             {
                 chainId: window.CONFIG.user.ChainId,
                 siteList: siteIds
             })
        await this.$store.dispatch('global/getAllHomepageCmsConfigsByChainId',
            {
                chainId: window.CONFIG.user.ChainId,
                isDraft: true
            })
      }

    },
    computed: {
      departments () {
        var departments = this.$store.getters['global/getDepartments']
        var response = []
        departments.forEach((department) => {
          response.push({ siteId: department.SiteId, siteName: department.SiteName, homepageUrl: 'Ingen tilhørighet' })
        });
        this.cmsConfigHomepages.forEach((cmsConfig) => {
          cmsConfig.Dto.Sites.forEach((site) => {
            response.find(e => e.siteId === site.SiteId).homepageUrl = cmsConfig.Dto.SiteUrl
          })
        })
        return response
      },
      cmsConfigHomepages () {
        return this.$store.getters['global/getCmsConfigHomepage']
      },
      
    }
  }
</script>
<style lang="scss" scoped>
  .newHomepageBtn {
    font-family: 'Niveau Grotesk';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 16px;
    color: #472449;
    border: 2px solid #472449;
    text-transform: unset !important;
    &--text {
      padding-top: 2px;
      margin: 0px;
    }
    &--icon {
      width: 18px;
      height: 18px;
      padding-top: 2px;
      margin-left: 8px;
    }
    &--text-small {
      padding-top: 2px;
      display: none;
    }
    }
    @media (max-width: 992px) {
      .newHomepageBtn {
        &--text {
          display: none;
        }
        &--text-small {
          display: initial;
          margin: 0px;
        }
      }
    }
    .modal-card-title {
      background: linear-gradient(90deg, #BFE5E8 0%, #EFDDD1 100%);
    }
    .modal-card-subtitle {
      margin-top: 16px;
    }
    .modal-card-text-checkbox{
      ::v-deep .v-label {
        margin-bottom: 0px;
      }
    }
    .dialog-actionbar{
      height: 52px;
      border-top: 0.5px solid rgb(211, 211, 211);
      gap: 8px;
      &-btn{
        text-transform: unset !important;
        font-family: 'Niveau Grotesk';
        font-style: normal;
        font-size: 14px;
        line-height: 16px;
        &-close {
          font-weight: 500;
        }
        &-create{
          gap: 8px;
          font-weight: 700;
          span{
            padding: 12px 10px 10px 10px;
          }
        }
      }
    }
    .modal-card-subtitle {
      font-family: 'Niveau Grotesk';
      font-weight: 400;
      font-size: 14px;
      line-height: 22px;
      letter-spacing: 0.1px;
      color: #222222 !important;
    }
</style>
